import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { WhatsAppIcon } from "@/components/SocialIcons";
import { useLang } from "@/context/LangContext";
import ContactButton from "@/components/ContactButton";

export default function ContactDetails({ settings }) {
  const { t } = useLang();
  const rows = [
    settings.contact_email && { id: "email", Icon: Mail, label: settings.contact_email, href: `mailto:${settings.contact_email}` },
    settings.contact_phone && { id: "phone", Icon: Phone, label: settings.contact_phone, href: `tel:${settings.contact_phone.replace(/[^+\d]/g, "")}` },
    settings.contact_whatsapp && { id: "whatsapp", Icon: WhatsAppIcon, label: `WhatsApp · ${settings.contact_whatsapp}`, href: `https://wa.me/${settings.contact_whatsapp.replace(/[^\d]/g, "")}`, external: true },
    settings.contact_address && { id: "address", Icon: MapPin, label: settings.contact_address },
    settings.contact_hours && { id: "hours", Icon: Clock, label: settings.contact_hours },
  ].filter(Boolean);

  if (!rows.length) return null;

  return (
    <div data-testid="contact-details" className="mt-10 border border-bone/10 bg-ink-2 p-6">
      <p className="font-mono text-[10px] tracking-[0.3em] text-brass">{t("contact.directTitle")}</p>
      {settings.contact_email && <ContactButton testId="contact-page-email-button" className="mt-4 w-fit" />}
      <ul className="mt-4 space-y-3">
        {rows.map(({ id, Icon, label, href, external }) => (
          <li key={id} data-testid={`contact-${id}`} className="flex items-start gap-3 font-mono text-[11px] tracking-[0.1em] text-bone-dim">
            <Icon size={14} className="mt-0.5 shrink-0 text-brass" />
            {href ? (
              <a href={href} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined} className="whitespace-pre-line transition-colors hover:text-brass">
                {label}
              </a>
            ) : (
              <span className="whitespace-pre-line">{label}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
